import * as avo from '../analytics/Avo';
// import { segmentDestinationInterface } from '../analytics/segment';
// import { config } from './config';

export const init = () => {
  // TODO: Add back
  // try {
  //   avo.initAvo(
  //     {
  //       env: config.tier === 'production' ? avo.AvoEnv.Prod : avo.AvoEnv.Dev,
  //       webDebugger: false,
  //     },
  //     {},
  //     segmentDestinationInterface
  //   );
  // } catch (err) {
  //   // noop
  // }
};
export const trackProductListViewed = () => void 0;
export const trackProductViewed = (args: { lotId: string }) => void 0;
export const trackLoginClicked = () => void 0;

export const trackBidStarted = () => {
  try {
    avo.bidStarted({} as any);
  } catch (err) {
    // noop
  }
};
export const trackBidStepCompleted = (args: { amount: number }) => {
  try {
    avo.bidStepCompleted({
      bidAmount: args.amount,
    } as any);
  } catch (err) {
    // noop
  }
};
export const trackBidPlaced = (args: { amount: number }) => {
  try {
    avo.bidPlaced({
      bidAmount: args.amount,
    } as any);
  } catch (err) {
    // noop
  }
};
export const trackBidError = (args: { error: Error }) => {
  try {
    avo.bidError({
      errorMsg: args.error.message,
    } as any);
  } catch (err) {
    // noop
  }
};

export const trackSignedInRedirect = () => void 0;
export const trackRegistrationTransactionalComplete = () => void 0;

export const trackPageView = (args: {
  pageUrl?: string;
  path?: string;
  referrer?: string;
  title?: string;
}) => {
  // void
};
